var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"id":"circle","viewBox":"0 0 8 8"}},[_c('g',[_c('circle',{staticStyle:{"stroke":"none"},attrs:{"r":"2","cx":"4","cy":"4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }